import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDoorOpen = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 12,
			fill: "#F7F8F7"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M12 5.25C11.1675 5.25 10.5 5.9175 10.5 6.75H5.25V17.25H4.5V18.75H19.5V17.25H18.75V6.75C18.75 5.9175 18.0825 5.25 17.25 5.25H12ZM12 6.75H17.25V17.25H12V6.75ZM6.75 11.25H8.25V12.75H6.75V11.25Z" })
	]
});
const ForwardRef = forwardRef(SvgDoorOpen);
export { ForwardRef as ReactComponent };
